import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '@weave-mui/material';
import { useAuth } from '../auth/AuthProvider';
/**
 * Role badge (pim-db-migration-admin–style), driven by `/v1/auth/me` role string.
 */
export default function RoleIndicator() {
    const { user } = useAuth();
    const theme = useTheme();
    if (!user) {
        return null;
    }
    const role = user.role || 'member';
    const getRoleColor = (r) => {
        switch (r.toLowerCase()) {
            case 'admin':
                return theme.palette.error.main;
            case 'developer':
                return theme.palette.primary.main;
            default:
                return theme.palette.text.secondary;
        }
    };
    const color = getRoleColor(role);
    const label = role.charAt(0).toUpperCase() + role.slice(1);
    return (_jsx("span", { style: {
            display: 'inline-block',
            padding: '3px 10px',
            borderRadius: '12px',
            fontSize: '11px',
            fontWeight: 600,
            color,
            border: `1px solid ${color}`,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
        }, title: `Role: ${role}`, children: label }));
}
